import {FileInfo} from './fileInfo';
import {AdditionalInfo} from './wizard/additional-info';
import {EnterpriseInfo} from './wizard/enterprise-info';
import {MitarbeiterBase} from './mitarbeiterBase';
import {FunctionRating} from './function-rating';

export class DataInput {
  mitarbeiter: MitarbeiterBase[];
  additionalInfo: AdditionalInfo;
  enterpriseInfo: EnterpriseInfo = {};
  fileInfo: FileInfo;
  funktionen: FunctionRating[];
  kontrollmodus: boolean;
  isExportFile: boolean;
  constructor() {
    this.additionalInfo = new AdditionalInfo();
    this.fileInfo = new FileInfo();
  }
}
